import LabeledValue from 'components/modules/labeledValue/LabeledValue';
import { postMarsMembershipLinkCard } from 'features/membership/api';
import CuminCardLinkConfirmPage from 'features/membership/components/cumin/CuminCardLinkConfirmPage';
import useCardLinkConfirm from 'features/membership/hooks/ginger/useCardLinkConfirm';
import { TEMPLATE_ALIAS_CODE } from 'features/membership/libs/const/aliasCode';
import { GingerCardLinkFormInputs } from 'features/membership/types/form';
import { FEATURES } from 'libs/features';
import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const GingerCardLinkConfirm: FC = () => {
  const location = useLocation();
  const state: null | { formData: GingerCardLinkFormInputs } = location.state;

  const formPagePath = `${FEATURES.membership.path}/${TEMPLATE_ALIAS_CODE.GINGER}/link`;
  const completePagePath = `${FEATURES.membership.path}/${TEMPLATE_ALIAS_CODE.GINGER}/link/complete`;
  const { onClickRegisterButton, onClickBackButton, isMutating } =
    useCardLinkConfirm(
      state,
      completePagePath,
      formPagePath,
      postMarsMembershipLinkCard
    );

  // 入力値が取得できない場合、入力画面へリダイレクト
  if (!state?.formData) return <Navigate to={formPagePath} />;

  return (
    <CuminCardLinkConfirmPage
      onClickRegisterButton={onClickRegisterButton}
      onClickBackButton={onClickBackButton}
      isMutating={isMutating}
      formData={state.formData}
      additionalLabeledValue={
        <LabeledValue label="PIN番号" value={state.formData.pin_code} />
      }
    />
  );
};

export default GingerCardLinkConfirm;
